import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const fetchFolders = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchFoldersAction => {
  return {
    type: actionsTypes.FETCH_FOLDERS,
    query,
    callback
  };
};

export const setFolders = (folders: actionsInterfaces.IFolder): actionsInterfaces.ISetFoldersAction => {
  return {
    type: actionsTypes.SET_FOLDERS,
    folders,
  };
};

export const getFolder = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchFolderAction => {
  return {
    type: actionsTypes.GET_FOLDER,
    query,
    callback
  };  
};

export const setFolder = (folder: actionsInterfaces.IFolder): actionsInterfaces.ISetFolderAction => {
  return {
    type: actionsTypes.SET_FOLDER,
    folder,
  };
};

export const addFolder = (folder: actionsInterfaces.IFolder, callback: IAsyncActionCallback): actionsInterfaces.IPostFolderAction => {
  return {
    type: actionsTypes.ADD_FOLDER,
    folder,
    callback
  };  
};

export const updateFolder = (folder: actionsInterfaces.IFolder, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateFolderAction => {
  return {
    type: actionsTypes.UPDATE_FOLDER,
    folder,
    callback
  };
};